import {OnInit} from '@angular/core';
import { BaseEntity } from '../models/baseEntity';


export abstract class GenericLovComponent implements OnInit {
  

entityName : string;

ngOnInit() {}

//----------------------------------------------------------------------------------------------------------------
selectRow(entity : BaseEntity){
  this.closeModal(entity);
}
//----------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------
selectRows(){
  this.closeModal(null);
}
//----------------------------------------------------------------------------------------------------------------

//----------------------------------------------------------------------------------------------------------------
close(){
    this.closeModal(null);
}
//----------------------------------------------------------------------------------------------------------------


serverPageNumber  : number = 0;
serverPageCount   : number = 0;
totalRowCount     : number = -1;
// ---------------------------------------------------

 //----------------------------------------------------------------------------------------------------------------
 nextPage() {
    if (this.serverPageNumber < (this.serverPageCount - 1)) {
      this.serverPageNumber++;
      this.loadData()
    }
  }
  
  previousPage() {
    if (this.serverPageNumber > 0) {
      this.serverPageNumber--;
      this.loadData()
    }
  }
 //----------------------------------------------------------------------------------------------------------------

abstract closeModal(entity : BaseEntity) : void;
abstract loadData() : void;

}
